import type { RequestConfig } from '@customTypes/index';
import type { WorkInviteItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type AcceptWorkInviteRequest = {
  workInviteId: string;
};

export type AcceptWorkInviteParams = RequestConfig<AcceptWorkInviteRequest>;

export const acceptWorkInvite = async ({
  params,
  config
}: AcceptWorkInviteParams) =>
  api.post<WorkInviteItemDto>(
    `/api/work/invites/${params.workInviteId}/accept`,
    config
  );
